import { render, staticRenderFns } from "./BaseUploadFile.vue?vue&type=template&id=0c60b1d1&scoped=true&"
import script from "./BaseUploadFile.vue?vue&type=script&lang=js&"
export * from "./BaseUploadFile.vue?vue&type=script&lang=js&"
import style0 from "./BaseUploadFile.vue?vue&type=style&index=0&id=0c60b1d1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c60b1d1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c60b1d1')) {
      api.createRecord('0c60b1d1', component.options)
    } else {
      api.reload('0c60b1d1', component.options)
    }
    module.hot.accept("./BaseUploadFile.vue?vue&type=template&id=0c60b1d1&scoped=true&", function () {
      api.rerender('0c60b1d1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/global/BaseUploadFile.vue"
export default component.exports